// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__EIvT_","fileDisabled":"File_fileDisabled__34BYM"};